module.exports = __webpack_public_path__ + "img/9f4ee42.png";